<template>
  <div id="data-list-list-view">
    <vs-tabs v-model="tabIndex" class="padTop20 tabSec">
      <vs-tab :label="item.label" v-for="item in vsTabsList" :key="item.id">
        <div class="flex search-wrap flex-bet">
          <template v-if="tabIndex == 0">
            <div class="flex">
              <gc-cmp-vs-input
              v-model="filterText"
              class="filterInput"
              placeholder="请输入主体账户名称"
              />
              <vs-button
                type="filled"
                size="small"
                @click.prevent="getMainList(1)"
                class="marLeft10"
                >查询</vs-button>
            </div>
            <vs-button v-if="filtering('main:add')" @click="addNewMain()">新增主体</vs-button>
          </template>
          <template v-else>
            <div class="flex">
              <v-select v-if="tabIndex == 1" v-model="customerId" :options="customerTypeOptions" :reduce="(opt) => opt.label" placeholder="请选择客户类型" style="width: 200px;" class="select-wrap" >
                <div slot="no-options">暂无选项</div>
              </v-select>
              <v-select v-if="tabIndex == 2" v-model="customerId" :options="customerStoreTypesOpts" :reduce="(opt) => opt.label" placeholder="请选择客户类型" class="select-wrap" >
                <div slot="no-options">暂无选项</div>
              </v-select>
              <!-- <v-select v-model="countryId" :options="options" :reduce="(opt) => opt.id" placeholder="请选择国家" class="select-wrap marLeft10" >
                <div slot="no-options">暂无选项</div>
              </v-select> -->
              <v-select v-model="regionId" :options="regionTypeOptions" :reduce="(opt) => opt" placeholder="请选择大区" class="select-wrap marLeft10" >
                <div slot="no-options">暂无选项</div>
              </v-select>
              <v-select v-model="provinceId" :options="provinceTypeOptions" :reduce="(opt) => opt" placeholder="请选择省" class="select-wrap marLeft10" >
                <div slot="no-options">暂无选项</div>
              </v-select>
              <v-select v-model="cityId" :options="cityTypeOptions" :reduce="(opt) => opt" placeholder="请选择市/区" class="select-wrap marLeft10" >
                <div slot="no-options">暂无选项</div>
              </v-select>
              <gc-cmp-vs-input v-model="userNamekey" class="filterInput marLeft10" placeholder="请输入客户名称/编码" />
              <vs-button type="filled" size="small" @click.prevent="getMainData(1)" class="marLeft10" >查询</vs-button>
            </div>
            <div class="flex">
              <vs-button v-if="filtering('main:StoreReset')" type="filled" size="small" @click.prevent="resetMainEvent()" class="marLeft10">批量重置主体</vs-button>
              <!-- <vs-button class="down-btn marLeft10" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button> -->
            </div>
          </template>
        </div>
        <div class="contentlist">
          <template v-if="tabIndex == 0">
            <vs-table :data="maindatalist" noDataText="暂无数据">
                <template slot="thead">
                  <vs-th style="width:110px">序号</vs-th>
                  <vs-th>主体名称</vs-th>
                  <vs-th>适用资金账户</vs-th>
                  <vs-th style="width:100px">操作</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <!-- 序号 -->
                    <vs-td :data="indextr" style="width:110px">{{ indextr + 1 }}</vs-td>
                    <!-- 主体名称 -->
                    <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                    <!-- 适用资金账户 -->
                    <vs-td :data="tr.moneyAccountType">
                      <template v-if="tr.moneyAccountType == 0">预付款账户</template>
                      <template v-if="tr.rebeatAccountType == 0">/达量奖励账户</template>
                      <template v-if="tr.subsidyAccountType == 0">/门店补贴账户</template>
                    </vs-td>
                    <!-- '操作', -->
                    <vs-td style="width:100px" class="flex">
                        <vs-button v-if="filtering('main:update')" class="vs-button" color="primary" type="flat" @click="addNewMain(tr)">编辑</vs-button>
                        <!-- <vs-button class="vs-button" color="primary" type="flat" @click="deleteMain(tr)">删除</vs-button> -->
                    </vs-td>
                  </vs-tr>
                </template>
            </vs-table>
          </template>
          <template v-if="tabIndex == 1">
            <vs-table multiple v-model="clientselected" :data="clientdatalist" noDataText="暂无数据">
                <template slot="thead">
                  <vs-th style="width:110px">序号</vs-th>
                  <vs-th style="width:150px">客户编码</vs-th>
                  <vs-th>客户名称</vs-th>
                  <vs-th style="width:110px">客户类型</vs-th>
                  <vs-th>未配置主体商品</vs-th>
                  <vs-th style="width:110px">操作</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <!-- 序号 -->
                    <vs-td :data="indextr" style="width:110px">{{ indextr+1 }}</vs-td>
                    <!-- 客户编码 -->
                    <vs-td :data="tr.outCode" style="width:150px">{{ tr.outCode }}</vs-td>
                    <!-- 客户名称 -->
                    <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                    <!-- 客户类型 -->
                    <vs-td :data="tr.type" style="width:110px">{{ tr.type }}</vs-td>
                    <!-- 未配置主体商品 -->
                    <vs-td :data="tr.notConfigureNum">{{ tr.notConfigureNum }}</vs-td>
                    <!-- '操作', -->
                    <vs-td style="width:110px">
                        <vs-button v-if="filtering('main:clientUpdate')" color="primary" type="flat" @click.stop="handleCheck(tr)">编辑</vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
            </vs-table>
          </template>
          <template v-if="tabIndex == 2">
            <vs-table multiple v-model="storeselected" :data="storedatalist" noDataText="暂无数据">
                <template slot="thead">
                  <vs-th>序号</vs-th>
                  <vs-th style="width:150px">门店编码</vs-th>
                  <vs-th>门店名称</vs-th>
                  <vs-th>所属客户</vs-th>
                  <vs-th>类别</vs-th>
                  <vs-th>操作</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <!-- 序号 -->
                    <vs-td :data="indextr">{{ indextr+1 }}</vs-td>
                    <!-- 门店编码 -->
                    <vs-td :data="tr.outCode" style="width:150px">{{ tr.outCode }}</vs-td>
                    <!-- 门店名称 -->
                    <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                    <!-- 所属客户 -->
                    <vs-td :data="tr.parentClient">{{ tr.parentClient }}</vs-td>
                    <!-- 类别 -->
                    <vs-td :data="tr.type">{{ tr.type }}</vs-td>
                    <!-- '操作', -->
                    <vs-td>
                        <vs-button v-if="filtering('main:StoreUpdate')" color="primary" type="flat" @click.stop="handleCheck(tr, indextr, false)">编辑</vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
            </vs-table>
          </template>
        </div>
        <gc-vs-pagination
          :pager="pager"
          @handleSizeChange="priceSizeChange"
          @handleCurrentChange="priceCurrentChange"
        ></gc-vs-pagination>
      </vs-tab>
    </vs-tabs>
    <!-- 添加主体 -->
    <vs-popup class="mainSec" :title="isEdit ? '编辑主体' : '添加主体'" :active.sync="isShowMain">
        <div class="filterWrap marTop18 marLeft18">
            <div class="flex flex-align">
                主体名称
                <gc-cmp-vs-input v-model="mainName" class="marLeft16" placeholder='请输入主体名称' />
            </div>
        </div>
        <div class="marLeft18">
          <div class="marBottom10">适用资金账户：</div>
          <el-checkbox-group v-model="assetSelected" class="check-wrap">
            <el-checkbox style="display:block" class="marBottom10" v-for="item in assetAccount" :label="item.label" :key="item.label">{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="marLeft18 padTop10" style="color:#E57373;">允许主体下存在指定的资金账户 </div>
        <div class="deliver-btn flex flexCenter marTop18">
            <vs-button color="primary" class="marLeft10 marRight10" type="filled" @click="saveAddMain()">保存</vs-button>
            <vs-button color="primary" class="marLeft10 marRight10" type="filled" @click="isShowMain = false">取消</vs-button>
        </div>
    </vs-popup>

    <!-- 批量重置主体 -->
    <vs-popup class="resetSec" title="批量重置主体（订单主体配置生成）" :active.sync="isResetMain">
        <div class="">
          <h5 v-show="tabIndex == 1">已选{{clientNum}}个客户</h5>
          <h5 v-show="tabIndex == 2">已选{{storeNum}}个门店</h5>
          <div class="marTop10">{{userName}}</div>
        </div>
        <div class="marTop18">
          <h5>选择商品（{{selectedGoods.length}}）</h5>
          <div class="flex marTop10">
            <v-select v-model="goodFirId" :options="goodsFirList" :reduce="(opt) => opt.id" placeholder="请选择一级分类" class="select-wrap" >
              <div slot="no-options">暂无选项</div>
            </v-select>
            <v-select v-model="goodSecId" :options="goodsSecList" :reduce="(opt) => opt.id" placeholder="请选择二级分类" class="select-wrap marLeft10" >
              <div slot="no-options">暂无选项</div>
            </v-select>
            <v-select v-model="goodThrId" :options="goodsThrList" :reduce="(opt) => opt.id" placeholder="请选择三级分类" class="select-wrap marLeft10" >
              <div slot="no-options">暂无选项</div>
            </v-select>
          </div>
          <gc-cmp-vs-table multiple v-model="selectedGoods" @selected="handleGoodsSelected" :data="gooddatalist" class="marTop18">
              <template slot="thead">
                <vs-th>序号</vs-th>
                <vs-th>商品图片</vs-th>
                <vs-th>69码</vs-th>
                <vs-th>商品名称</vs-th>
                <vs-th>单位</vs-th>
                <vs-th>商品ID</vs-th>
                <vs-th>SN前缀</vs-th>
              </template>
              <template slot-scope="{data}">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <!-- 序号 -->
                      <vs-td :data="indextr">{{ indextr + 1 }}</vs-td>
                      <!-- 商品图片 -->
                      <vs-td :data="tr.picUrl">
                        <img class="tableImg" :src="tr.picUrl ? tr.picUrl[0] : ''" alt="">
                      </vs-td>
                      <!-- 69码 -->
                      <vs-td :data="tr.barCode">{{ tr.barCode }}</vs-td>
                      <!-- 商品名称 -->
                      <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                      <!-- 单位 -->
                      <vs-td :data="tr.unit">{{ tr.unit }}</vs-td>
                      <!-- 商品ID -->
                      <vs-td :data="tr.code">{{ tr.code }}</vs-td>
                      <!-- SN前缀 -->
                      <vs-td :data="tr.snCodePrefix">{{ tr.snCodePrefix }}</vs-td>
                    </vs-tr>
                </tbody>
              </template>
          </gc-cmp-vs-table>
        </div>
        <div class="marTop10">
          <h5 class="marBottom20">选择主体</h5>
          <div class="main-radio">
            <vs-radio class="marRight20" v-model="radioGroup" v-for="item in mainSecList" :key="item.id" :vs-value="item.id" >{{item.name}}</vs-radio>
          </div>
        </div>
        <div class="deliver-btn flex flexCenter marTop18">
            <vs-button color="primary" class="marLeft10 marRight10" type="filled" @click="confirmReset">确认重置</vs-button>
            <vs-button color="primary" class="marLeft10 marRight10" type="filled" @click="isResetMain = false">取消</vs-button>
        </div>
    </vs-popup>
  </div>
</template>

<script>
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import VsTable from "@/modules/order/vsTable/vsTable"
import VsTd from "@/modules/order/vsTable/vsTd"
import VsTh from "@/modules/order/vsTable/vsTh"
import VsTr from "@/modules/order/vsTable/vsTr"
import {Mod_Clients} from "../../server-api/Clients";
import {
  $busErrorCode,
  getThreeCategory,
} from "@/modules/commodity-sys/common.js";
import { CommodityMainApi } from "@/modules/server-api/commodity-sys/main-manage";
import { Customer_Types_Opts, Customer_Store_Types_Opts } from "@/modules/server-api/commodity-sys/on-shelves"; //客户类型
export default {
  data() {
    return {
      tabIndex: 0,
      filterText: "",

      vsTabsList: [
        { id: "main", label: "主体账户配置" },
        { id: "user", label: "客户&商品主体关联" },
        { id: "store", label: "门店&商品主体关联" },
      ], //tab标签页
      pager: {
        page: 1,
        size: 20,
        total: 0,
      },

      customerTypeOptions: [],//客户类型选项
      customerStoreTypesOpts: Customer_Store_Types_Opts, //门店类型选项
      regionTypeOptions: [], //大区选项
      provinceTypeOptions: [], //省份选项
      cityTypeOptions: [], //城市选项
      customerId: "", //客户
      regionId: "", //大区
      provinceId: "", //省份
      cityId: "", //城市
      userNamekey: "", //客户名称、编码
      maindatalist: [], //主体账户列表
      clientdatalist: [], //客户列表
      clientselected: [], //选中的客户账号
      clientselectedId: [], //选中的客户id
      storedatalist: [], //门店列表
      storeselected: [], //选中的门店账号
      storeselectedId: [], //选中的门店id
      isShowMain: false, //添加/编辑主体弹窗
      isEdit: false,
      mainInfo: '', //编辑主体信息
      mainName: '', //主体名称
      assetAccount: [{
        label: '预存款余额',
        value: '预存款余额',
      },{
        label: '返利账户',
        value: '返利账户',
      },{
        label: '门店补贴',
        value: '门店补贴',
      }],  //适用资金账户
      assetSelected: [], //选中资金账户
      isResetMain: false, //批量重置主体
      clientNum: 0,
      storeNum: 0,
      userName: '',
      selectedGoods: [], //选择商品
      skuId: [], //选中商品id
      mainSecList: [], //弹窗主体列表
      radioGroup: '', //选中主体
      gooddatalist: [], //批量商品列表
      goodFirId: "", //一级分类
      goodSecId: "", //二级分类
      goodThrId: "", //三级分类
      goodsFirList: [],
      goodsSecList: [],
      goodsThrList: []
    };
  },
  mounted() {
    let that = this;
    that.getMainList();  //获取主体列表
    that.getAreaValue();  //获取地址
    that.getFirstType();   //获取商品一级分类
    this.getCustomerTypeList();
  },
  methods: {
    //获取客户&商品主体关联的客户类型
    async getCustomerTypeList(){
        let res= await Mod_Clients.conditionQuery();
        this.customerTypeOptions=res.type.map((v)=>{
            return{
                label:v.customerName,
                id:v.customerCode
            }
        })
        console.log(res);
    },
    // 批量重置主体
    resetMainEvent(){
      let that = this;
      if(that.tabIndex == 1 && that.clientselected.length == 0){
        return that.$notifyError('请批量选择客户');
      }else if(that.tabIndex == 2 && that.storeselected.length == 0){
        return that.$notifyError('请批量选择门店');
      }
      that.getResetsList();
      that.isResetMain = true;
    },

    //客户、门店查询
    getMainData(){
      let that = this;
      if(that.tabIndex == 0){
        that.getMainList();
      }else if(that.tabIndex == 1){
        that.getClientList();
      }else if(that.tabIndex == 2){
        that.getStoreList();
      }
    },

    //编辑操作
    handleCheck(val){
      console.log(val)
      let that = this;
      that.isResetMain = true;
      that.userName = val.name;
      if(that.tabIndex == 1){
        that.clientNum = 1;
        that.clientselectedId = [val.id];
      }else{
        that.storeNum = 1;
        that.storeselectedId = [val.id];
      }
    },

    // 获取大区、省
    async getAreaValue(){
      let that = this,
          type = '';
      // that.$vs.loading();
      type = that.tabIndex == 2 ? 'store' : 'client';
      let resp = await CommodityMainApi.getAreaValue({
        type: type
      });
      if(resp.code == 0 && resp.succ == 1){
        let result = resp.result;
        that.regionTypeOptions = result.area;
        that.provinceTypeOptions = result.province;
      }
    },

    // 获取市区
    async getCityValue(){
      let that = this;
      let resp = await CommodityMainApi.getCityValue({
        province: that.provinceId,
        type: that.tabIndex == 1 ? 'client' : 'store'
      })
      if(resp.code == 0 && resp.succ == 1){
        let result = resp.result;
        that.cityTypeOptions = result;
      }
    },

    /**
     * 获取主体列表
     */
    async getMainList(page){
      let that = this,
          params = {};
        console.log(page);
      that.$vs.loading();
      params = {
        data: that.filterText,
        pageNo: page?page:that.pager.page,
        pageSize: that.pager.size
      }
      let resp = await CommodityMainApi.getMainList(params);
      if(resp.code == 0 && resp.succ == 1){
        console.log(resp)
        let result = resp.result;
        that.maindatalist = result.records;
        that.pager.total = result.total;
        that.$vs.loading.close();
      }else{
        that.$notifyError(resp.error);
        that.$vs.loading.close();
      }
    },

    /**
     * 获取客户列表
     */
    async getClientList(page){
      let that = this,
          params = {};
      that.$vs.loading();
      params.data = {
          type: that.customerId ? that.customerId : '',
          area: that.regionId ? that.regionId : '',
          province: that.provinceId ? that.provinceId : '',
          city: that.cityId ? that.cityId : '',
          search: that.userNamekey ? that.userNamekey : '',
        }
        Object.keys(params.data).forEach(item=>{
            if(params.data[item] !== ''){
                params.pageNo = 1;
                params.pageSize = 20;
            }else{
                params.pageNo = that.pager.page;
                params.pageSize = that.pager.size;
            }
        })
        this.$forceUpdate();

      let resp = await CommodityMainApi.getClientList(params);
      if(resp.code == 0 && resp.succ == 1){
        let result = resp.result;
        that.clientdatalist = result.list;
        that.pager.total = result.totalCount;
        that.$vs.loading.close();
      }else{
        that.$notifyError(resp.error);
        that.$vs.loading.close();
      }
    },

    /**
     * 获取门店列表
     */
    async getStoreList(page) {
      let that = this,
          params = {};
      params.data = {
          type: that.customerId ? that.customerId : '',
          area: that.regionId ? that.regionId : '',
          province: that.provinceId ? that.provinceId : '',
          city: that.cityId ? that.cityId : '',
          search: that.userNamekey ? that.userNamekey : '',
        }
        Object.keys(params.data).forEach(item=>{
            if(params.data[item] !== ''){
                params.pageNo = 1;
                params.pageSize = 20;
            }else{
                params.pageNo = that.pager.page;
                params.pageSize = that.pager.size;
            }
        })
        this.$forceUpdate();
      let resp = await CommodityMainApi.getStoreList(params);
      console.log(resp)
      if(resp.code == 0 && resp.succ == 1){
        let result = resp.result;
        that.storedatalist = result.list;
        that.pager.total = result.totalCount;
        that.$vs.loading.close();
      }else{
        that.$notifyError(resp.error);
        that.$vs.loading.close();
      }
    },

    /**
     * 获取批量重置商品
     */
    async getResetsList() {
      let that = this,
          params = {};
      if(that.goodThrId !=0 || that.goodSecId != 0 || that.goodFirId != 0){
        params.data = {
          categoryId: that.goodThrId ? that.goodThrId : (that.goodSecId ? that.goodSecId : that.goodFirId)
        }
      }else{
        params.data = {
          categoryId: ''
        }
      }
      let resp = await CommodityMainApi.getResetsList(params);
      if(resp.code == 0 && resp.succ == 1){
        let result = resp.result;
        that.gooddatalist = result.skus.list;
        that.mainSecList = result.mainBodies;
        if(that.selectedGoods.length !== 0){
          that.selectedGoods = that.gooddatalist;
        }
      }else{
        that.$notifyError(resp.error);
      }
    },

    /**
     * 获取批量重置商品一级分类
     */
    async getFirstType() {
      let that = this;
      let resp = await CommodityMainApi.getGoodsFirstType({});
      if(resp.code == 0 && resp.succ == 1){
        let result = resp.result;
        result.first.map(item => {
          item.label = item.categoryName;
        })
        let allsec = {label: '全部',id: 0}
        result.first.unshift(allsec)
        that.goodsFirList = result.first;
        that.getResetsList();
      }else{
        that.$notifyError(resp.error);
      }
    },

    /**
     * 获取批量重置商品二级分类
     */
    async getGoodsOrderType() {
      let that = this;
      let resp = await CommodityMainApi.getGoodsOrderType({
        categoryId: that.goodSecId ? that.goodSecId : that.goodFirId
      })
      if(resp.code == 0 && resp.succ == 1){
        let result = resp.result;
        result.subtype.map(item => {
          item.label = item.categoryName;
        })
        let allsec = {label: '全部',id: 0}
        result.subtype.unshift(allsec)
        if(that.goodSecId){
          that.goodsThrList = result.subtype;
        }else{
          that.goodsSecList = result.subtype;
        }
        that.getResetsList();
      }else{
        that.$notifyError(resp.error);
      }
    },

    //新增主体 /编辑主体回显
    async addNewMain(tr) {
      let that = this;
      that.isShowMain = true;
      that.isEdit = false;
      // 编辑回显
      if(tr.id){
        that.isEdit = true;
        let resp = await CommodityMainApi.showEditMain({
          id: tr.id
        });
        if(resp.code == 0 && resp.succ == 1){
          let result = resp.result;
          that.mainInfo = result;
          that.mainName = result.name;
          let assetSelected = [];
          if(result.moneyAccountType == 0){
            assetSelected.push('预存款余额')
          }
          if(result.rebeatAccountType == 0){
            assetSelected.push('返利账户')
          }
          if(result.subsidyAccountType == 0){
            assetSelected.push('门店补贴')
          }
          that.assetSelected = assetSelected;
        }else{
          that.$notifyError(resp.error);
        }
      }
    },

    //删除主体
    deleteMain(tr){
      let that = this;
      that.$vs.dialog({
        type: 'confirm',
        title: `操作提示`,
        text: `您确认删除该主体吗？`,
        acceptText: '确认',
        cancelText: '取消',
        accept: async () => {
          let resp = await CommodityMainApi.deleteMain({
            id: tr.id
          });
          if(resp.code == 0 && resp.succ == 1){
            that.$notifySuccess(resp.result);
            that.getMainList();
          }else{
            that.$notifyError(resp.error);
          }
        }
      });
    },

    //更改每页条数
    priceSizeChange(val) {
      let that = this;
      that.pager.size = val;
      that.getMainData();
    },
    priceCurrentChange(val) {
      let that = this;
      that.pager.page = val;
      that.getMainData();
    },
    //添加弹窗商品的时候
    async handleGoodsSelected (tr) {
        // console.log(tr);
    },

    // 保存主体
    async saveAddMain(){
      let that = this,
          params = {},
          assetOne = '',
          assetTwo = '',
          assetThr = '';
      if(!that.mainName){
        return that.$notifyError('请输入主体名称');
      }
      if(that.assetSelected.length == 0){
        return that.$notifyError('请选择适用资金账户');
      }

      assetOne = that.assetSelected.findIndex(item => item == '预存款余额'),
      assetTwo = that.assetSelected.findIndex(item => item == '返利账户'),
      assetThr = that.assetSelected.findIndex(item => item == '门店补贴');
      console.log(assetOne, assetTwo, assetThr);
      params = {
        name: that.mainName,
        moneyAccountType: assetOne == -1 ? 1 : 0,
        rebeatAccountType: assetTwo == -1 ? 1 : 0,
        subsidyAccountType: assetThr == -1 ? 1 : 0,
      }
      if(that.isEdit){
        // 修改
        params.id = that.mainInfo.id;
        let resp = await CommodityMainApi.saveEditMain(params);
        if(resp.code == 0 && resp.succ == 1){
          that.$notifySuccess(resp.result);
          that.isShowMain = false;
          that.getMainList();
        }else{
          that.$notifyError(resp.error);
        }
      }else{
        // 新增
        let resp = await CommodityMainApi.saveAddMain(params);
        if(resp.code == 0 && resp.succ == 1){
          that.$notifySuccess(resp.result);
          that.isShowMain = false;
          that.getMainList();
        }else{
          that.$notifyError(resp.error);
        }
      }

    },

    //确认重置
    confirmReset(){
      let that = this;
      console.log(that.skuId)
      if(that.skuId.length == 0){
        return that.$notifyError('请选择商品');
      }
      if(!that.radioGroup){
        return that.$notifyError('请选择主体');
      }
      that.$vs.dialog({
        type: "confirm",
        title: `确认重置？`,
        text: `确认后，已选客户和商品的主体配置清除并将按本次配置生效。`,
        acceptText: "确认",
        cancelText: "取消",
        accept: async () => {
          let params = {
            userIds: that.tabIndex == 1 ? that.clientselectedId : that.storeselectedId,
            skuCodes: that.skuId,
            bodyId: that.radioGroup,
            type: that.tabIndex == 1 ? 'client' : 'store'
          }
          let resp = await CommodityMainApi.saveResetsBody(params);
          console.log(resp)
          if(resp.code == 0 && resp.succ == 1){
            that.$notifySuccess(resp.result);
            that.isResetMain = false;
            if(that.tabIndex == 1){
              that.getClientList();
            }else if(that.tabIndex == 2){
              that.getStoreList();
            }
          }else{
            that.$notifyError(resp.error);
          }
        },
      })
    }
  },
  components: {
    GcCmpVsTable,
    GcCmpVsInput,
    VsTable,
    VsTd,
    VsTh,
    VsTr,
  },
  watch: {
    tabIndex(value) {
      let that = this;
      that.filterText = "";
      that.pager.page = 1;
      that.customerId = "";
      that.regionId = ""; //大区
      that.provinceId = ""; //省份
      that.cityId = ""; //城市
      that.userNamekey = "";
      that.clientselected = [];
      that.storeselected = [];
      that.userName = [];
      that.skuId = [];
      that.clientselectedId = [];
      that.storeselectedId = [];
      if (value == 0) {
        //主体账户列表
        that.getMainList();
      } else if(value == 1) {
        that.getClientList();
      } else if(value == 2) {
        that.getStoreList();
      }
    },
    isShowMain(val){
      let that = this;
      that.mainName = '';
      that.assetSelected = [];
    },
    clientselected(array) {
      let that = this,
          clientName = [],
          clientId = [];
      array.map(ele => {
        clientName.push(ele.name);
        clientId.push(ele.id);
      })
      that.clientNum = array.length;
      that.userName = clientName.join('，');
      that.clientselectedId = clientId;
    },
    storeselected(array) {
      let that = this,
          storeName = [],
          storeId = [];
      array.map(ele => {
        storeName.push(ele.name);
        storeId.push(ele.id);
      })
      that.storeNum = array.length;
      that.userName = storeName.join('，');
      console.log(that.userName)
      that.storeselectedId = storeId;
    },
    selectedGoods(array){
      let that = this,
          skuId = [];
      array.map(ele => {
        skuId.push(ele.code)
      })
      that.skuId = skuId;
    },
    isResetMain(val){
      let that = this;
      if(!val){
        that.clientselected = [];
        that.storeselected = [];
        that.selectedGoods = [];
        that.radioGroup = '';
        that.goodFirId = '';
        that.goodSecId = '';
        that.goodThrId = '';
      }
    },
    goodFirId(val){
      let that = this;
      that.goodSecId = '';
      if(val){
        that.getGoodsOrderType();
      }else{
        that.getResetsList();
        that.goodsSecList = [];
      }
    },
    goodSecId(val){
      let that = this;
      that.goodThrId = '';
      console.log(that.goodFirId)
      if(val){
        that.getGoodsOrderType();
      }else{
        that.getResetsList();
        that.goodsThrList = [];
      }
    },
    goodThrId(val){
      let that = this;
      if(val || val == 0){
        that.getResetsList();
      }
    },
    provinceId(val){
      let that = this;
      that.cityId = '';
      if(val){
        that.getCityValue();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
.main-radio{
  height: 100px;
  overflow: hidden;
  overflow-y: scroll;
}
.mainSec /deep/ .vs-popup{
  width: 400px !important;
}
.resetSec /deep/ .vs-popup{
  width: 800px !important;
}
.tabSec .v-select{
  width: 130px;
}
.tabSec /deep/ [dir] .vs__dropdown-menu{
  min-width: 130px;
}
.tabSec .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large){
  padding: 0.75rem 1rem;
}
.filterInput{
  width: 150px;
}
.flex-bet{
    justify-content: space-between;
}
.flex-align{
  align-items: center;
}
.search-wrap {
  margin-top: 20px;
  margin-bottom: 20px;
}
.priceTable .vs-table thead th {
  min-width: 165px;
}
.priceTable .vs-table thead th .vs-table-text {
  float: right;
}
.priceTable .vs-table thead th.data-th .vs-table-text {
  float: left;
}
.tableImg{
  width: 64px;
  height: 64px;
}
</style>
<style>
.vuesax-app-is-ltr .con-vs-dialog{
  z-index: 1510;
}
</style>
